import { render, staticRenderFns } from "./import-issues.vue?vue&type=template&id=412259fa&scoped=true&"
import script from "./import-issues.ts?vue&type=script&lang=ts&"
export * from "./import-issues.ts?vue&type=script&lang=ts&"
import style0 from "./import-issues.vue?vue&type=style&index=0&id=412259fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412259fa",
  null
  
)

export default component.exports